import React from "react";

import { Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import { Link } from "ds/Button";
import Input from "ds/Input";

import * as S from "../InitializeWizard.styles";

const Credentials = ({ inputs, handleInputChange }) => {
  const intl = useIntl();

  return (
    <form>
      <Typography.Title tag="h3">
        {intl.formatMessage({
          id: "wizard.project.provisioning.enter.credentials"
        })}
      </Typography.Title>

      <Typography.BodyText size="small">
        {intl.formatMessage(
          {
            id: "wizard.project.provisioning.adobe.credentials"
          },
          {
            link: chucks => (
              <Link
                analyticId="wizard.project.provisioning.link.support.url"
                variant="link"
                href={intl.formatMessage({
                  id: "wizard.project.provisioning.link.support.url"
                })}
              >
                {chucks}
              </Link>
            ),
            code: txt => (
              <Typography.Code variant="inline">{txt}</Typography.Code>
            )
          }
        )}
      </Typography.BodyText>
      <S.InputContainer>
        <Input
          width="50%"
          placeholder={intl.formatMessage({
            id: "wizard.project.provisioning.username"
          })}
          label={intl.formatMessage({
            id: "wizard.project.provisioning.username"
          })}
          name="username"
          analyticId="wizard.project.provisioning.username"
          value={inputs.username}
          onChange={elt => handleInputChange(elt)}
          required
        />
        <Input
          width="50%"
          placeholder={intl.formatMessage({
            id: "wizard.project.provisioning.password"
          })}
          label={intl.formatMessage({
            id: "wizard.project.provisioning.password"
          })}
          name="password"
          value={inputs.password}
          onChange={elt => handleInputChange(elt)}
          required
          analyticId="wizard.project.provisioning.password"
          type="password"
        />
      </S.InputContainer>
    </form>
  );
};

export default Credentials;
